import React from 'react';
import styled, { keyframes } from 'styled-components';

const Jiggling = keyframes`
  0% {
    transform: rotate(0deg)
  }
  20% {
    transform: rotate(20deg)
  }
  40% {
    transform: rotate(-20deg)
  }
  60% {
    transform: rotate(20deg)
  }
  80% {
    transform: rotate(-20deg)
  }
  100% {
    transform: rotate(0deg)
  }
`;

const JigglingPhone = styled.svg`
  overflow: visible;
  &.animate #JigglingPhone {
    animation: ${Jiggling} 0.5s infinite;
    animation-iteration-count: 1;
    transform-origin: center;
  }
`;

export default function PhoneIcon({
  animate,
}: {
  animate?: boolean;
}): JSX.Element {
  return (
    <JigglingPhone
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      className={animate ? 'animate' : ''}
    >
      <path
        id="JigglingPhone"
        fill="rgba(255,255,255,1)"
        fillRule="nonzero"
        d="M6.207 8c-.45 0-2.073-.155-4.064-2.144C.156 3.868 0 2.244 0 1.795 0 1.057.951.004 1.194 0h.54c.073 0 .14.044.168.112l.797 1.88a.183.183 0 01-.06.216c-.75.563-.999.737-1.003 1.021 0 .612 2.522 3.134 3.13 3.134.288-.002.48-.248 1.044-1a.18.18 0 01.216-.058l1.863.794c.067.028.111.095.111.168v.54C7.998 7.05 6.945 8 6.207 8z"
      />
    </JigglingPhone>
  );
}
